import { render } from "./createCustomer.vue?vue&type=template&id=b611ece4&scoped=true"
import script from "./createCustomer.vue?vue&type=script&lang=js"
export * from "./createCustomer.vue?vue&type=script&lang=js"

import "./createCustomer.vue?vue&type=style&index=0&id=b611ece4&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b611ece4"]])

export default __exports__